import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const GET_APPOINTMENTS = 'GET_APPOINTMENTS';
export const GET_APPOINTMENTS_SUCCESS = 'GET_APPOINTMENTS_SUCCESS';
export const GET_APPOINTMENTS_FAILURE = 'GET_APPOINTMENTS_FAILURE';

// Action Creators
export const fetchGetAppointments = () => ({
  type: GET_APPOINTMENTS,
});

export const fetchGetAppointmentsSuccess = (data) => ({
  type: GET_APPOINTMENTS_SUCCESS,
  payload: data,
});

export const fetchGetAppointmentsFailure = (error) => ({
  type: GET_APPOINTMENTS_FAILURE,
  payload: error,
});

// Thunk Function
export const getAppointmentsCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetAppointments(data, external));
    try {
      const response = await getMethodWithToken(
        url.getAppointmentsListProviderAdmin,
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetAppointmentsSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetAppointmentsFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetAppointmentsFailure(error.message));
    }
  };
};
